module.exports = __webpack_public_path__ + "img/judicialElevator.861b1d0a.gif";